<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
<div class="panel panel-default ">
	  <div [ngClass]="" class="panel-body">
      {{message}}
    </div>
</div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close class="btn btn-danger">{{cancelbutton}}</button>
    <button mat-button mat-dialog-close class="btn btn-success" (click)="startSend()">{{sendbutton}}</button>
</mat-dialog-actions>